import { post, get } from "@/libs/http";
import { createSimplePersistentQuery } from "@/hooks/use-api-query";
import { NotificationEventType } from "../constant/index";

interface NotificationButtonLink {
  button_link: string;
  button_text: string;
}
export interface NotificationItem {
  amount: string; // 金额
  award_type: number; // 奖励类型
  button_links: Array<NotificationButtonLink>;  //按钮链接信息
  content: string; // 内容
  create_at: number; // 创建时间
  currency: string; // 币种（USDT,INR,BRL）
  event_status: number; // 事件状态：1处理成功，2处理失败，3处理中
  event_type: NotificationEventType; // 事件类型: 1平台消息 2充值, 3提现, 4代理佣金, 5VIP, 6Rummy
  event_sub_type: number; // 事件子类：1=欢迎加入，2=等级提升，3=奖励过期
  event_time: number; // 事件时间
  expire_time: number; // 过期时间
  id: string; // 消息ID
  img_urls: string; // 图片地址
  is_read: number; // 是否已读：1=否，2=是
  title: string; // 标题
  locale: string; // 语言环境
  order_id: string; // 其它信息(如订单id,提现id等)
  isShowAll?: boolean; //是否显示全部，记录前端状态
  msg_config_id: string; // 消息配置ID（平台消息才有值）
  jump_params: string; // 消息额外参数
}

export interface NotificationListRes {
  list: Array<NotificationItem>;
  total: number;
}



// 分页获取站内信列表
export const getNotificationByPage = (params: {
  msg_type: number;
  page: number;
  size: number;
}) => {
  return get<NotificationListRes>('/message/inbox', { params });
};

export interface NotificationBannerRes {
  msg_id: string; // 消息id
  amount: string; //金额
  award_type: number; //奖励类型
  content: string; // 消息内容
  currency: string; //币种（USDT,INR,BRL）
  event_status: number; //事件状态：1处理成功，2处理失败，3处理中
  event_type: NotificationEventType; //事件类型: 1平台消息 2充值, 3提现, 4代理佣金, 5VIP, 6Rummy
  event_sub_type: number; // 事件子类：1=欢迎加入，2=等级提升，3=奖励过期
  order_id: string; // 提现/充值订单ID
  locale: string; // 语言环境
  title: string; // 标题
  button_links: Array<NotificationButtonLink> | null; //按钮链接信息
  msg_count: number; // 消息数量
  jump_params: string; // 消息额外参数
  msg_config_id: string; // 消息配置ID（平台消息才有值）
}


// 获取最近一条消息
export const getNotificationBanner = (isPolling?: boolean) => {
  return get<NotificationBannerRes>('/message/notice', {
    isPollingRequest: !!isPolling,
  } as any);
};

interface NotificationReadRes {
  status: number;
}

export enum NotificationReadStatus {
  UNREAD = 1,
  READED = 2
}

// 站内信设置已读
export const setNotificationRead = (params: {
  id: string; // 消息ID
}) => {
  return post<NotificationReadRes>('/message/inbox/read', params);
};


// 站内信设置全部已读
export const setNotificationAllRead = (params: {
  msg_type: number; // 消息ID，平台1，个人2
}) => {
  return post<NotificationReadRes>('/message/inbox/readall', params);
};

export interface NotificationUnreadNumRes {
  all_unread_count: number;
  personal_unread_count: number;
  platform_unread_count: number;
}


// 获取站内信未读数量
export const getNotificationUnreadNum = () => {
  return get<NotificationUnreadNumRes>('/message/inbox/unread/count');
};

// 查询键名，用于缓存失效
export const NOTIFICATION_UNREAD_QUERY_KEY = ['notification-unread-num'];

// 导入 useQueryClient hook 用于获取 queryClient 实例
import { useQueryClient } from '@tanstack/react-query';

/**
 * 创建更新未读消息数量的函数
 * 当消息被标记为已读时，调用此函数使所有使用未读消息数量的组件更新
 * @returns 使缓存失效的函数
 */
export const useInvalidateNotificationUnreadNum = () => {
  const queryClient = useQueryClient();

  return () => {
    // 使缓存失效，所有使用该查询的组件都会重新获取数据
    queryClient.invalidateQueries({ queryKey: NOTIFICATION_UNREAD_QUERY_KEY });
  };
};

// 获取站内信未读数量的 Hook
export const useNotificationUnreadNum = createSimplePersistentQuery(
  getNotificationUnreadNum,
  NOTIFICATION_UNREAD_QUERY_KEY,
  {
    persist: true,
    persistKey: 'notification-unread-num-cache',
    refetchOnWindowFocus: true, // 窗口聚焦时重新获取
  }
);